import { AccessibleText } from '@/components/AccessibleText'
import { ScreenReaderHidden } from '@/components/ScreenReaderHidden'
import { ScreenReaderNotifier } from '@/components/ScreenReaderNotifier'
import { useStepper } from '@/components/Stepper/StepperContext'

import { BodyM, HeadingM, HeadingS } from '@/components/Typography'

import { sanitizeUrl } from '@/core/utils/dom/security'

import { useFgtsLoanSimulator } from '../../core/context'
import {
  ACCESSIBLE_DISCLAIMER,
  makeCurrencyAccessible,
  SIMULATION_RESULT,
  SIMULATION_RESULT_STEP,
} from '../../core/utils'
import AccessibleHighlightedText from '../AccessibleHighlightedText'
import { Cta as Button } from '../styles'

import FgtsAmount from './FgtsAmount'
import SalaryAndMonthsAmount from './SalaryAndMonthsAmount'
import * as Simulation from './styles'
import { useSimulationResult } from './useSimulationResult'

const SimulationResult = () => {
  const { hasFgts, amountReceivable, backStep, ctaHref } = useFgtsLoanSimulator()
  const { birthDateText } = useSimulationResult()
  const { activeStep } = useStepper()

  const shouldFocus = activeStep === SIMULATION_RESULT_STEP
  const AmountLabelComponent = hasFgts ? FgtsAmount : SalaryAndMonthsAmount

  return (
    <Simulation.Container>
      <HeadingS html={SIMULATION_RESULT.title} />
      <AccessibleHighlightedText {...birthDateText} />

      <AmountLabelComponent />

      <Simulation.Button
        modifier="ghost"
        onClick={backStep}
        event={{ label: `Alterar simulaçao ${SIMULATION_RESULT.title}` }}
      >
        Alterar Simulação
      </Simulation.Button>
      <Simulation.Divider aria-hidden />
      <ScreenReaderHidden as={BodyM} html={SIMULATION_RESULT.amoutLabel} />
      <ScreenReaderHidden as={HeadingM} html={amountReceivable} />
      <ScreenReaderNotifier
        enabled={shouldFocus}
        allowSuppressOtherElements={false}
        label={`Você irá receber aproximadamente: ${makeCurrencyAccessible(amountReceivable)}`}
      />
      <AccessibleText text={SIMULATION_RESULT.disclaimer} accessibleText={ACCESSIBLE_DISCLAIMER} />
      <Simulation.Wrapper>
        <Simulation.ButtonLink
          source={sanitizeUrl(ctaHref || SIMULATION_RESULT.cta)}
          modifier="solid"
          color="primary"
          event={{ label: `Antecipar agora ${SIMULATION_RESULT.title}` }}
        >
          Antecipar agora
        </Simulation.ButtonLink>
        <Button
          modifier="outline"
          color="primary"
          onClick={backStep}
          aria-label="Voltar para a página de formulário"
          event={{ label: `voltar ${SIMULATION_RESULT.title}` }}
        >
          Voltar
        </Button>
      </Simulation.Wrapper>
    </Simulation.Container>
  )
}
export default SimulationResult
